import React, { useEffect, useState } from 'react';
import CategoryList from '../components/CategoryList';
import BannerProduct from '../components/BannerProduct';
import HorizontalCardProduct from '../components/HorizontalCardProduct';
import { useNavigate } from 'react-router-dom';
import ROLE from '../common/role';
import { useSelector } from 'react-redux';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import NotificationBar from '../components/NotificationBar'; // Import NotificationBar component

const Home = () => {
    const user = useSelector(state => state?.user?.user);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        setLoading(true);
        if (user) {
            if (user?.role === ROLE.ADMIN) {
                if (user?.type === "Medicine") {
                    navigate("/admin-home");
                    setLoading(false);
                } 
                else if(user?.type === "Cosmetic") {
                    navigate("/admin-cosmetic-home");
                    setLoading(false);
                }
                else if (user?.type ==="Admin"){
                    navigate("/admin-panel/all-users");
                    setLoading(false);
                }
                
            } 
            /*
            if (user?.role === ROLE.SALESMAN) {
        
              navigate("/salesManPanel/salesManViewOrders");
              setLoading(false);
    
          }
            */
            else {
                setLoading(false);
            }
        } else {
            setLoading(false);
        }
    }, [user, navigate]);

    if (loading) {
        return (
            <div className="flex justify-center items-center h-screen">
                <AiOutlineLoading3Quarters className="animate-spin text-6xl text-blue-500" />
            </div>
        );
    }

    return (
        <div className="home-page">
            <NotificationBar />
            <div>
                <BannerProduct />
                <CategoryList userType={"Default"} />
                <HorizontalCardProduct status={"New Arrival"} heading={"منتجات حديثة الوصول"} />
                <HorizontalCardProduct status={"Promo Pack"} heading={"العروض المجمعة"} />
                <HorizontalCardProduct status={"Sale"} heading={"التخفيضات"} />
            </div>
        </div>
    );
}

export default Home;
